var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94553 10.556C8.27353 10.556 7.74553 10.336 7.36153 9.896C6.98553 9.448 6.79753 8.796 6.79753 7.94C6.79753 7.092 6.98553 6.448 7.36153 6.008C7.74553 5.56 8.27353 5.336 8.94553 5.336C9.62553 5.336 10.1575 5.56 10.5415 6.008C10.9255 6.448 11.1175 7.092 11.1175 7.94C11.1175 8.796 10.9255 9.448 10.5415 9.896C10.1575 10.336 9.62553 10.556 8.94553 10.556ZM8.86153 14L13.8055 5.456H15.1375L10.1815 14H8.86153ZM8.94553 9.584C9.25753 9.584 9.48553 9.456 9.62953 9.2C9.77353 8.944 9.84553 8.524 9.84553 7.94C9.84553 7.372 9.76953 6.96 9.61753 6.704C9.47353 6.44 9.24953 6.308 8.94553 6.308C8.64953 6.308 8.42953 6.44 8.28553 6.704C8.14153 6.96 8.06953 7.372 8.06953 7.94C8.06953 8.516 8.14153 8.936 8.28553 9.2C8.42953 9.456 8.64953 9.584 8.94553 9.584ZM15.0415 14.084C14.3615 14.084 13.8295 13.864 13.4455 13.424C13.0695 12.976 12.8815 12.32 12.8815 11.456C12.8815 10.608 13.0695 9.964 13.4455 9.524C13.8295 9.084 14.3615 8.864 15.0415 8.864C15.7215 8.864 16.2495 9.084 16.6255 9.524C17.0095 9.964 17.2015 10.612 17.2015 11.468C17.2015 12.324 17.0095 12.976 16.6255 13.424C16.2495 13.864 15.7215 14.084 15.0415 14.084ZM15.0415 13.112C15.3455 13.112 15.5695 12.984 15.7135 12.728C15.8575 12.464 15.9295 12.044 15.9295 11.468C15.9295 10.9 15.8535 10.488 15.7015 10.232C15.5575 9.968 15.3375 9.836 15.0415 9.836C14.7375 9.836 14.5135 9.968 14.3695 10.232C14.2255 10.488 14.1535 10.9 14.1535 11.468C14.1535 12.044 14.2255 12.464 14.3695 12.728C14.5135 12.984 14.7375 13.112 15.0415 13.112Z",
    fill: "#1D6295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsPercentage);
export default __webpack_public_path__ + "static/media/as_percentage.8450dba1e140e191fd82f24bd95a379a.svg";
export { ForwardRef as ReactComponent };